import { useMemo } from 'react';

import { createRequiredContext } from '~/utils/createRequiredContext';

type ApplicantInfoContextType = {
    applicantId: string | undefined;
};

const [useApplicantInfoContext, ContextProvider] =
    createRequiredContext<ApplicantInfoContextType>('ApplicantInfoContext');

type Props = {
    children: React.ReactNode;
    applicantId?: string;
};

const ApplicantInfoContextProvider: React.FC<Props> = ({ applicantId, children }) => {
    const value = useMemo(() => ({ applicantId }), [applicantId]);
    return <ContextProvider value={value}>{children}</ContextProvider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export { useApplicantInfoContext };
export default ApplicantInfoContextProvider;
